import React from 'react';

import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { Container, Form } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';

import { FormGroup } from 'react-bootstrap';
import { FormLabel } from 'react-bootstrap';
import { FormControl } from 'react-bootstrap';
import { Button } from 'react-bootstrap';

import ResourceStore from '../../../stores/ResourceStore';

const PortalResourceCreatePage = ({ portalResources }) => {
    const navigate = useNavigate();

    const store = ResourceStore((state) => state);

    useEffect(() => {
        store.resetPortalResource();
        // The [] is for specifying dependencies, and for componentDidMount lifecycle equivalent
        // we need to specify no dependencies.
        // See https://stackoverflow.com/questions/53945763/componentdidmount-equivalent-on-a-react-function-hooks-component
    }, []);

    return (
        <Container style={{ marginTop: '10px', width: '100%' }}>
            <Row className="show-Container">
                <Col xs={12} md={8}>
                    <Button
                        onClick={() => {
                            navigate('/portalResource');
                        }}
                    >
                        Back to list
                    </Button>

                    <div>PortalResource Creation Page</div>

                    <br />

                    <form>
                        <FormGroup>
                            <FormLabel>
                                title<span className="text-danger">*</span>
                            </FormLabel>
                            <FormControl
                                type="text"
                                onChange={(e) => {
                                    store.updateAttribute(
                                        'title',
                                        e.target.value,
                                    );
                                }}
                            />
                        </FormGroup>

                        <br />
                        <br />

                        <Button
                            onClick={() => {
                                store.create(
                                    store.portalResource,
                                    () => {
                                        alert('Your portal resource was saved');
                                        navigate('/portalResource');
                                    },
                                    () => {
                                        alert('Something went wrong!');
                                    },
                                );
                            }}
                        >
                            Create
                        </Button>

                        <Button
                            style={{ marginLeft: '5px' }}
                            onClick={() => {
                                navigate('/portalResource');
                            }}
                        >
                            Cancel
                        </Button>
                    </form>
                </Col>
            </Row>
        </Container>
    );
};

export default PortalResourceCreatePage;
